// Auto-generated by scripts/write-build-info.mjs
export const BUILD_VERSION = "2.1.5";
export const BUILD_SHA = "c417be9";
